export const fbUser = 'fb_user';
